import { useProgramActions, useProgramStore } from '#client/stores/program/useProgramStore';
import { Box, ButtonGroup, Button, BlockStack } from '@shopify/polaris';
import { useNavigate } from 'react-router';
import ProgramArchiveModal from './components/ProgramArchiveModal/ProgramArchiveModal';

export default function ProgramActionButtons() {
    const navigate = useNavigate();

    // Zustand store hooks
    const { handleCancelProgram, handleProgramSubmit } = useProgramActions();
    const mode = useProgramStore.use.mode();
    const isLoading = useProgramStore.use.isLoading();
    const allProducts = useProgramStore.use.allProducts();
    const restrictToEligibleProducts = useProgramStore.use.restrictToEligibleProducts();

    return (
        <Box paddingBlock="600">
            <BlockStack inlineAlign="end">
                <ButtonGroup>
                    {mode === 'edit' && <ProgramArchiveModal />}
                    {(mode === 'edit' || mode === 'create') && <Button onClick={() => handleCancelProgram(navigate)}>Cancel</Button>}
                    {mode === 'create' && (
                        <Button variant="primary" onClick={() => handleProgramSubmit(navigate)} loading={isLoading} disabled={allProducts.length === 0 && restrictToEligibleProducts}>
                            Save Program
                        </Button>
                    )}
                    {mode === 'edit' && (
                        <Button variant="primary" onClick={() => handleProgramSubmit(navigate)} loading={isLoading} disabled={allProducts.length === 0 && restrictToEligibleProducts}>
                            Update Program
                        </Button>
                    )}
                </ButtonGroup>
            </BlockStack>
        </Box>
    );
}
